<section class="section-custom">
  <h2 class="section-title">Dados de Referência do Pagamento</h2>
  <div class="row fileira-gradeada">
    <div class="col-md-2">
      <label class="label-formulario control-label">
        CPF/CNPJ
      </label>
      <p class="form-control-static dado-formulario">
        <span>
          {{ this.pagamento.ni | formatCpfCnpjPipe:this.pagamento.tipoNi | vazio }}
        </span>
      </p>
    </div>
    <div class="col-md-2">
      <label class="label-formulario control-label">
        Processo
      </label>
      <p class="form-control-static dado-formulario">
        {{ this.pagamento.pgtoNrProcesso | vazio }}
      </p>
    </div>
    <div class="col-md-2">
      <label class="label-formulario control-label">
        UA de Arrecadação
      </label>
      <p class="form-control-static dado-formulario">
        {{ this.pagamento.pgtoUa | formatUa | vazio }}
      </p>
    </div>
    <div class="col-md-3">
      <label class="label-formulario control-label">
        Parcela
      </label>
      <p class="form-control-static dado-formulario">
        {{ this.pagamento.pgtoNrParcela | vazio }}
      </p>
    </div>
    <div class="col-md-3">
      <label class="label-formulario control-label">
        Referência
      </label>
      <p class="form-control-static dado-formulario">
        {{ this.pagamento.pgtoNrReferencia | vazio }}
      </p>
    </div>
  </div>
</section>

<section class="section-custom">
  <h2 class="section-title">Informações do Documento</h2>
  <div class="row fileira-gradeada">
    <div class="col-md-3">
      <label class="label-formulario control-label">
        No. do Documento
      </label>
      <p class="form-control-static dado-formulario">
        {{ this.pagamento.pgtoNrIdAr | vazio }}
      </p>
    </div>
    <div class="col-md-3">
      <label class="label-formulario control-label">
        Tipo Documento
      </label>
      <p class="form-control-static dado-formulario">
        {{ this.pagamento.tipoDocumento?.nomeAbreviado | vazio }}
      </p>
    </div>
    <div class="col-md-3">
      <label class="label-formulario control-label">
        Natureza do Documento
      </label>
      <p class="form-control-static dado-formulario">
        {{ this.pagamento.natureza?.descricao | vazio }}
      </p>
    </div>
    <div class="col-md-3">
      <label class="label-formulario control-label">
        Data Emissão
      </label>
      <p class="form-control-static dado-formulario">
        {{ this.pagamento.pgtoDtGerRegSistOrig | date: 'dd/MM/yyyy' | vazio }}
      </p>
    </div>
  </div>
  <div class="row fileira-gradeada">
    <div class="col-md-3">
      <label class="label-formulario control-label">
        No. do Pagamento
      </label>
      <p class="form-control-static dado-formulario">
        {{ this.pagamento.pgtoNr | vazio }}
      </p>
    </div>
    <div class="col-md-3">
      <label class="label-formulario control-label">
        Modalidade Arrecadação
      </label>
      <p class="form-control-static dado-formulario">
        {{ this.pagamento.modalidadeArrecadacao?.descricao | vazio }}
      </p>
    </div>
    <div class="col-md-3">
      <label class="label-formulario control-label">
        Data de Recepção
      </label>
      <p class="form-control-static dado-formulario">
        {{ this.pagamento.pgtoBDtRecepcao | date: 'dd/MM/yyyy' | vazio }}
      </p>
    </div>
    <div class="col-md-3">
      <label class="label-formulario control-label">
        ID CEF
      </label>
      <p class="form-control-static dado-formulario">
        {{ this.pagamento.pgtoNrIdDepositoCef | vazio }}
      </p>
    </div>
  </div>
  <div class="row fileira-gradeada">
    <div class="col-md-3">
      <label class="label-formulario control-label">
        BDA/Seq
      </label>
      <p class="form-control-static dado-formulario">
        {{ this.pagamento.pgtoBNrBdaSq | vazio }}
      </p>
    </div>
    <div class="col-md-3">
      <label class="label-formulario control-label">
        Origem do Erro
      </label>
      <p class="form-control-static dado-formulario">
        {{ this.pagamento.origemErro?.descricao | vazio }}
      </p>
    </div>
    <div class="col-md-3">
      <label class="label-formulario control-label">
        Valor Devolvido
      </label>
      <p class="form-control-static dado-formulario">
        {{ this.pagamento.getnValorDevolvido ?? 0 | formatCurrency | vazio }}
      </p>
    </div>
    <div class="col-md-3">
      <label class="label-formulario control-label">
        Valor Transformado
      </label>
      <p class="form-control-static dado-formulario">
        {{ this.pagamento.getnValorTransformado ?? 0 | formatCurrency | vazio }}
      </p>
    </div>
  </div>
  <div class="row fileira-gradeada">
    <div class="col-md-12">
      <label class="label-formulario control-label">
        Sistema Gerador
      </label>
      <p class="form-control-static dado-formulario">
        <span>
          {{ this.pagamento.sistemaGerador?.descricao | vazio }}
        </span>
      </p>
    </div>
  </div>
</section>

<section class="section-custom">
  <h2 class="section-title">Dados de Autenticação</h2>
  <div class="row fileira-gradeada">
    <div class="col-md-3">
      <label class="label-formulario control-label">
        No. de Protocolo
      </label>
      <p class="form-control-static dado-formulario">
        {{ this.pagamento.pgtoNrProtocolDebCc | vazio }}
      </p>
    </div>
    <div class="col-md-6">
      <label class="label-formulario control-label">
        Código de Barras
      </label>
      <p class="form-control-static dado-formulario">
        {{ this.pagamento.codigoBarras | codigoBarrasPipe | vazio }}
      </p>
    </div>
  </div>
</section>

<div class="row">
  <div class="col-md-4">
    <fieldset class="grupo background-inherit">
      <legend class="grupo-titulo text-nowrap">Informações de Saldo</legend>
      <label class="label-formulario control-label">
        Saldo
      </label>
      <p class="form-control-static dado-formulario">
        {{ this.pagamento.getnSaldoDisponivel | vazio }}
      </p>
    </fieldset>
  </div>
  <div class="col-md-4">
    <fieldset class="grupo background-inherit">
      <legend class="grupo-titulo text-nowrap">Saldo não Levantado</legend>
      <div class="row">
        <div class="col-md-6">
          <label class="label-formulario control-label">
            Disponível
          </label>
          <p class="form-control-static dado-formulario">
            {{ this.pagamento.pgtoBVlDjeSdnl | formatCurrency | vazio }}
          </p>
        </div>
        <div class="col-md-6">
          <label class="label-formulario control-label">
            Utilizado
          </label>
          <p class="form-control-static dado-formulario">
            {{ this.pagamento.pgtoBVlDjeSunl | formatCurrency | vazio }}
          </p>
        </div>
      </div>
    </fieldset>
  </div>
  <div class="col-md-4">
    <fieldset class="grupo background-inherit">
      <legend class="grupo-titulo text-nowrap">Saldo Transformado</legend>
      <div class="row">
        <div class="col-md-6">
          <label class="label-formulario control-label">
            Disponível
          </label>
          <p class="form-control-static dado-formulario">
            {{ this.pagamento.pgtoBVlDjeSdtd | formatCurrency | vazio }}
          </p>
        </div>
        <div class="col-md-6">
          <label class="label-formulario control-label">
            Utilizado
          </label>
          <p class="form-control-static dado-formulario">
            {{ this.pagamento.pgtoBVlDjeSutd | formatCurrency | vazio }}
          </p>
        </div>
      </div>
    </fieldset>
  </div>
</div>
<div class="row" style="margin-top: 20px;">
  <div class="col-md-offset-3 col-md-6">
    <via-receitas-pagamento [valoresDocumento]="this.pagamento.valoresDocumento"
                            [exibirLabels]="this.pagamento.possuiMultaJuros">
    </via-receitas-pagamento>
  </div>
</div>

<ng-template #templateVazio>
  <p class="dado-formulario form-control-static">{{ '' | vazio }}</p>
</ng-template>